import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HOME } from "@/constants/testIds";

export function FinalCTA() {
  return (
    <section
      data-testid={HOME.finalCta}
      className="mx-auto w-full max-w-6xl px-5 pb-24 pt-8 sm:px-8 sm:pb-32"
    >
      <div className="relative overflow-hidden rounded-3xl border border-border bg-card p-10 sm:p-14">
        {/* Very subtle indigo wash — used once, here */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-primary/15 blur-3xl"
        />

        <div className="relative flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <div className="max-w-xl">
            <h2 className="text-balance text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              Stop staring at the blank reply box.
            </h2>
            <p className="mt-3 text-base leading-relaxed text-muted-foreground">
              Get a copilot that drafts, polishes and follows up — so you can
              spend your time on the work clients hired you for.
            </p>
          </div>

          <div className="flex shrink-0 flex-col items-stretch gap-2 sm:flex-row sm:items-center">
            <Button
              asChild
              size="lg"
              className="h-11 rounded-xl bg-primary px-5 text-sm font-medium text-primary-foreground shadow-sm hover:bg-primary/90"
            >
              <Link to="/workspace" data-testid={HOME.finalCtaButton}>
                Get started — it&apos;s free
                <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="h-11 rounded-xl border-border bg-transparent px-5 text-sm font-medium text-foreground hover:bg-secondary"
            >
              <Link to="/pricing">View pricing</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
